import * as React from 'react'
import {exhaustive} from '@freckle/exhaustive'
import {cn} from '@frontrow/console/src/lib/utils'

type StyleT = 'body-1' | 'body-2' | 'subtitle-2' | 'caption-1'

type Props = {
  children?: React.ReactNode
  style: StyleT
  htmlElement?: 'div' | 'p' | 'span'
  addClass?: string
}

export function Text(props: Props): React.ReactElement {
  const {children, style, addClass, htmlElement = 'p'} = props
  const className = cn(getBaseClassname(style), addClass)
  return React.createElement(htmlElement, {className}, children)
}

const BASE = 'not-italic text-body'
const BASE_SEMIBOLD = `${BASE} font-semibold`

function getBaseClassname(style: StyleT): string {
  switch (style) {
    case 'body-1':
      return `${BASE} text-[16px] leading-[22px] tracking-[0.5px]`
    case 'body-2':
      return `${BASE} text-[14px] leading-[20px] tracking-[0.25px]`
    case 'subtitle-2':
      return `${BASE_SEMIBOLD} text-[14px] leading-[20px] tracking-[0.25px]`
    case 'caption-1':
      return `${BASE_SEMIBOLD} text-[12px] leading-[16px] tracking-[0.4px]`
    default:
      return exhaustive(style)
  }
}
